// jshint esversion: 8

export default {
  SET_ID: (state, payload) => state.id = payload,
  SET_NAME: (state, payload) => state.name = payload,
  SET_LOGO: (state, payload) => state.logo = payload,
};
